import Dialog, {
  DefaultDialogActions,
  DialogBody,
  DialogTitle,
} from '@/components/Dialog';
import { classes } from './utils';

export type OrderProductStatusDialogProps = {
  onContinue: () => void;
  onClose: () => void;
};

export default function OrderProductStatusDialog({
  onContinue,
  onClose,
}: OrderProductStatusDialogProps) {
  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <DialogTitle title="Order fulfilled" onClose={onClose} />
      <DialogBody className={classes.body}>
        <p className={classes.paragraph}>
          Set all products to <b>Complete</b>?
        </p>
      </DialogBody>
      <DefaultDialogActions
        confirmLabel="Update"
        onCancel={onClose}
        onConfirm={onContinue}
      />
    </Dialog>
  );
}
